import { useDispatch, useSelector } from "react-redux";
// import { format } from "date-fns";
import { ArrowRightIcon } from "../../../assets/ArrowRight";
// import { ClockIcon } from "../../../assets/Clock";
import { DeleteIcon } from "../../../assets/Delete";
import { DeliveryIcon } from "../../../assets/Delivery";
// import { ForkIcon } from "../../../assets/Fork";

import { Card } from "../../../components/ui/card";
// import {
//   Tabs,
//   TabsContent,
//   TabsList,
//   TabsTrigger,
// } from "../../../components/ui/tabs";
// import { DeliveryTimePicker } from "../../../components/DeliveryTimePicker";
// import {
//   PICKUP_MIN_HOURS_FROM_NOW,
//   getPickupMaxTime,
// } from "../../../utils/pickupWindow";
import {
  TimeIssue,
  validateScheduledTime,
} from "../../../utils/scheduledTimeValidation";
import { getPickup } from "../../../store/selectors/pickup";
import {
  fulfillmentMode,
  isPickupSelected,
} from "../../../store/selectors/fulfillment";
// import { setFulfillmentMode } from "../../../store/slices/fulfillment";
// import { setPickupOn } from "../../../store/slices/pickup";
import { requestCartLocationGate } from "../../../lib/cartLocationGate";
// import { PickupBranchDrawer } from "../../pickup/ui/PickupBranchDrawer";

import { impactOccuer } from "../../../utils/hapticEvents";
import {
  getBasketItemUnitPrice,
  selectBasketItems,
  selectTotalPrice,
} from "../../../store/selectors/basket";
import { Button } from "../../../components/ui/button";
import { Minus } from "../../../assets/Minus";
import { PlusIcon } from "../../../assets/Plus";

import { formatPrice } from "../../../utils/getPrice";
import { formatModifierLines } from "../libs/formatModifiers";
import { cn } from "../../../lib/utils";

import { EmptyBasket } from "../../../components/EmptyBasket";
import { AuthDrawer } from "../../../components/AuthDrawer";
import { useNavigate } from "react-router-dom";
import { BackButtonHide } from "../../../utils/BackButton";
import { useTranslation } from "react-i18next";
import { localized, useAppLanguage } from "../../../utils/localized";
import { userInfo } from "../../../store/selectors/user";

import { useGetAddresses } from "../../addresses/services/getAddresses";
import { Skeleton } from "../../../components/ui/skeleton";
import { truncate } from "../../../utils/truncate";

import { formatDeliveryTime } from "../../../utils/deliveryTimeConverter";
import { userSavedAddresses } from "../../../store/selectors/userAddresses";
import { useEffect, useMemo, useState } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from "../../../components/ui/drawer";
import { DeliveryDetail } from "../../../store/selectors/delivery";
import { useAddToBasket } from "../services/addToBasket";
import { isCartLimitReached } from "../libs/cartLimit";
import { BasketCrossSellCarousel } from "./BasketCrossSellCarousel";
import { OrderExtras } from "./OrderExtras";

import { useClearBasket } from "../services/clearBasket";
import { useDecreaseFromBasket } from "../services/decreaseFromBasket";
import { useQueryClient } from "@tanstack/react-query";
import { useGetNearesBranch } from "@/modules/addresses/services/getNearBranch";
import { useGetDeliveryDetail } from "../services/getDeliveryDetail";
import { useOrderCalculation } from "../services/useOrderCalculation";
import { AppDispatch, RootState } from "../../../store";
import {
  hydrateBasketFromStorage,
  type BasketItem,
} from "../../../store/slices/basketSlice";
import { getStoredBasket } from "../libs/basketStorage";
import { useFooterTopSlot } from "../../../layout/main";
import { ProductImage } from "../../../components/ProductImage";

// const promoCodeSchema = z.object({
//   promocode: z.string(),
// });
// type PromoCodeSchema = z.infer<typeof promoCodeSchema>;

export const Basket = () => {
  const { t } = useTranslation();
  BackButtonHide();
  const dispatch = useDispatch<AppDispatch>();
  const queryClient = useQueryClient();
  const totalPrice = useSelector(selectTotalPrice);
  const { nearest } = useGetNearesBranch();
  const branchId = nearest?.branch_id ?? 0;
  useGetDeliveryDetail(totalPrice, branchId);

  const user = useSelector(userInfo);
  const savedAddresses = useSelector(userSavedAddresses);
  const { addToBasket } = useAddToBasket();
  const { decreaseFromBasket } = useDecreaseFromBasket();
  const { addresses, isLoading: isLoadingAddresses } = useGetAddresses();
  const { clearBasket } = useClearBasket();
  const { deliveryTime, deliveryPrice } = useSelector(DeliveryDetail);
  const [open, setOpen] = useState(false);
  const fulfillmentTab = useSelector(fulfillmentMode);
  // What the user picked drives the UI; whether a branch is chosen yet only
  // decides whether the order can actually proceed.
  const isPickupMode = fulfillmentTab === "pickup";
  const hasPickupBranch = useSelector(isPickupSelected);
  const pickup = useSelector(getPickup);
  const [authOpen, setAuthOpen] = useState(false);
  // Гость нажал строку адреса: после входа ведём его на экран адреса, а не
  // в оформление.
  const [pendingAddressRedirect, setPendingAddressRedirect] = useState(false);
  // const [branchDrawerOpen, setBranchDrawerOpen] = useState(false);
  // Значение читала только отключённая шторка; сеттер остался в проверке заказа.
  const [, setShowPickupTimePicker] = useState(false);
  // The pickup time survives in localStorage, so a time that was fine when it
  // was picked can be long gone by the time the user gets back to the basket.
  // Checkout re-checks it at payment; without the same check here the basket
  // happily shows a stale time and waves the order through.
  const [, setPickupTimeIssue] = useState<TimeIssue>(null);
  // const pickupMaxTime = getPickupMaxTime(new Date());
  // One auth drawer serves two entry points — remember which one opened it so
  // logging in resumes the right action.
  const [, setAuthIntent] = useState<"checkout" | "pickup">("checkout");

  const navigate = useNavigate();
  const basketItems = useSelector(selectBasketItems);
  const isAvailabilityPending = useSelector(
    (state: RootState) => state.basket.isAvailabilityPending,
  );
  // «Нет в наличии» показываем только по свежей сверке. Пока она в пути,
  // такая позиция рисуется как доступная, с шиммером на месте статуса и
  // степпера — а не мигает красным, чтобы через полсекунды вернуться.
  const isResolving = (item: BasketItem) =>
    isAvailabilityPending && !item.isAvailable;

  // The app-level basket sync (AppProvider -> useGetBasket) runs once at
  // startup and never again (staleTime: Infinity), so redux can drift from
  // storage mid-session — e.g. after a branch-menu availability pass. Storage
  // is the source of truth, so re-read it every time this screen opens
  // instead of making the user reload the page.
  useEffect(() => {
    const stored = getStoredBasket();

    dispatch(hydrateBasketFromStorage(stored));
  }, [dispatch]);

  const lang = useAppLanguage();

  const userAddress = isLoadingAddresses
    ? null
    : addresses.find(
        (address) => String(address._id) === String(savedAddresses),
      );
  // Display order only — storage keeps the real order. Anything the branch
  // can't fulfil floats to the top so the user sees what needs fixing first.
  const sortedBasketItems = useMemo(
    () =>
      [...basketItems].sort(
        (a, b) =>
          Number(a.isAvailable || isResolving(a)) -
          Number(b.isAvailable || isResolving(b)),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [basketItems, isAvailabilityPending],
  );

  const availableBasketItems = useMemo(
    () =>
      basketItems.filter((item) => {
        const itemWithBackendAvailability = item as typeof item & {
          isAvail?: boolean;
        };

        return (
          item.isAvailable !== false &&
          itemWithBackendAvailability.isAvail !== false
        );
      }),
    [basketItems],
  );

  // Расчёт корзины для суммы на кнопке внизу. Промокод и баллы выбираются на
  // чекауте — там тот же расчёт, выбор хранится в сторе.
  const calculation = useOrderCalculation({
    availableBasketItems,
    userAddress,
    deliveryPrice: deliveryPrice || 0,
    branchId,
    isPickupMode,
  });
  const { isCalculatingCart } = calculation;
  // Сумма на кнопке корзины — просто сумма товаров, как в списке над ней:
  // без доставки, промокода и баллов. Скидки выбирают и показывают на
  // чекауте, а итог calculate-cart их уже учитывает — вернувшись из чекаута с
  // промокодом, корзина показывала бы сумму меньше, чем стоят её товары.
  const lastPrice = totalPrice;

  const handleRemove = async (id: number, cartKey?: string) => {
    impactOccuer("light");
    queryClient.invalidateQueries({ queryKey: ["delivery-detail"] });
    await decreaseFromBasket({ product_id: id, cartKey, remove_all: false });
  };

  // An unavailable item can't be re-added from here, so send the user back to
  // the menu anchored at its category instead of dumping them at the top of
  // the home page. Same mechanism the banners use (see Banners.tsx).
  const handleChangeUnavailable = (categoryId: number, cartKey: string) => {
    impactOccuer("light");
    sessionStorage.setItem("scrollToCategory", String(categoryId));
    // Lets the home screen pin a reminder of which item is being replaced.
    sessionStorage.setItem("replacingCartKey", cartKey);
    navigate("/");
  };

  // An unavailable item has nothing to decrement down to, so it goes in one
  // call rather than through `handleRemove`. Applies on tap — same as the
  // replace-items sheet, which no longer asks twice either.
  const handleRemoveUnavailable = async (cartKey: string) => {
    impactOccuer("light");
    queryClient.invalidateQueries({ queryKey: ["delivery-detail"] });
    await clearBasket({ cartKeys: [cartKey] });
  };

  const handleRemoveAllNotAvailable = async () => {
    impactOccuer("light");
    queryClient.invalidateQueries({ queryKey: ["delivery-detail"] });

    await clearBasket({
      cartKeys: basketItems
        .filter((item) => !item.isAvailable)
        .map((item) => item.cartKey),
    });

    setOpen(false);

    // This drawer only ever opens from "checkout", so confirming here means
    // the user already asked to proceed — carry on instead of making them
    // press the button a second time. Unless nothing is left to order.
    if (basketItems.some((item) => item.isAvailable)) {
      proceedToCheckout();
    }
  };

  const handelClear = async () => {
    queryClient.invalidateQueries({ queryKey: ["delivery-detail"] });
    await clearBasket({});
  };


  const proceedToCheckout = () => {
    // Pickup orders have a branch instead of a delivery address, so the
    // address-completion detour doesn't apply — but a branch still has to be
    // chosen before there's anywhere to collect the order from.
    if (isPickupMode) {
      if (hasPickupBranch) {
        navigate("/checkout");
      } else {
        navigate("/restaurants/map", { state: { returnTo: "/cart" } });
      }
      return;
    }

    navigate(
      !savedAddresses && (!addresses || addresses.length === 0)
        ? "/adding-address"
        : !savedAddresses && addresses.length > 0
          ? "/profile/addresses"
          : "/checkout",
    );
  };

  // Right after a fresh login, the addresses query has only just become enabled (it's
  // gated on the auth token) and may still be loading — wait for it to settle so we
  // don't wrongly send a returning user with saved addresses to /adding-address.
  const [pendingCheckoutRedirect, setPendingCheckoutRedirect] = useState(false);

  useEffect(() => {
    if (pendingCheckoutRedirect && user.isAuth && !isLoadingAddresses) {
      setPendingCheckoutRedirect(false);
      proceedToCheckout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingCheckoutRedirect, user.isAuth, isLoadingAddresses]);

  const goToCheckout = () => {
    impactOccuer("light");
    if (!user.isAuth) {
      setAuthIntent("checkout");
      setAuthOpen(true);
      return;
    }

    // Re-checked here and not only on the checkout screen: a time picked an
    // hour ago is still sitting in the store, and nothing else would stop the
    // user from ordering for a moment that has already passed.
    if (isPickupMode && pickup.pickupOn) {
      const issue = validateScheduledTime({
        isPickup: true,
        pickupOn: pickup.pickupOn,
        deliveryOn: null,
      });

      if (issue) {
        setPickupTimeIssue(issue);
        setShowPickupTimePicker(true);
        return;
      }
    }

    if (basketItems.find((item) => !item.isAvailable)) {
      setOpen(true);
      return;
    }
    proceedToCheckout();
  };

  useFooterTopSlot(
    basketItems.length === 0 ? null : (
      // The padding lives on the backdrop, the fixed height on the row inside:
      // collapsing both onto one element squeezed the strip to 48px total and
      // pinned it against the nav.
      <div
        className="px-8 pt-3 pb-3"
        style={{
          borderRadius: "24px 24px 0 0",
          // The footer's own blur/gradient layers below are tuned for the
          // (shorter) nav-only footer height and are almost fully transparent
          // at the very top — give this row its own solid-enough backdrop so it
          // doesn't show the page content scrolling behind it.
          background: "rgba(240, 240, 240, 0.92)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          transform: "translateZ(0)",
          WebkitTransform: "translateZ(0)",
        }}
      >
        <div className="flex h-12 flex-row items-center justify-between gap-3">
          <div className="flex flex-col space-y-1">
            <p className="text-body-base-medium">
              {formatPrice(lastPrice)} {t("sum")}
            </p>
          </div>
          <Button
            data-testid="cart-checkout-button"
            className="h-12 w-[164px] px-4 rounded-[32px] bg-button-primary font-semibold"
            onClick={goToCheckout}
          >
            {t("checkout")}
          </Button>
        </div>
      </div>
    ),
  );

  return (
    <>
      {basketItems.length === 0 ? (
        <EmptyBasket />
      ) : (
        <div className="flex flex-col h-full overflow-y-auto">
          <div className="flex flex-col space-y-4">
            <div className="flex flex-row items-center justify-between px-4 pt-2">
              <p className="text-display-xl">{t("basket")}</p>
              <div onClick={handelClear}>
                <DeleteIcon className="text-text-icon-secondary" />
              </div>
            </div>
            <Card className="rounded-2xl p-1 mx-4">
              {/* Самовывоз временно отключён: табы «Доставка/Самовывоз», строка
                  выбора филиала и строка времени самовывоза закомментированы,
                  остаётся только строка адреса доставки. */}
              {/* <Tabs
                value={fulfillmentTab}
                onValueChange={(value) => {
                  impactOccuer("soft");
                  dispatch(setFulfillmentMode(value as "delivery" | "pickup"));
                }}
              >
                <TabsList className="relative grid w-full grid-cols-2">
                  <div
                    className="absolute inset-y-1 left-1 rounded-[8px] bg-fill-base shadow-[0px_2px_16px_0px_#00000014] transition-transform duration-300 ease-out"
                    style={{
                      width: "calc(50% - 4px)",
                      transform:
                        fulfillmentTab === "pickup"
                          ? "translateX(100%)"
                          : "translateX(0%)",
                    }}
                  />
                  <TabsTrigger
                    value="delivery"
                    data-testid="cart-tab-delivery"
                    className="relative z-10 bg-transparent data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                  >
                    {t("delivery")}
                  </TabsTrigger>
                  <TabsTrigger
                    value="pickup"
                    data-testid="cart-tab-pickup"
                    className="relative z-10 bg-transparent data-[state=active]:bg-transparent data-[state=active]:shadow-none"
                  >
                    {t("pickup")}
                  </TabsTrigger>
                </TabsList>
                <TabsContent value="delivery"> */}
              <div
                data-testid="cart-delivery-address-row"
                className="flex flex-row justify-between items-center px-1 py-2"
                onClick={() => {
                  impactOccuer("soft");

                  // Адрес заводится на аккаунт: гостя сначала на регистрацию,
                  // после неё вернёмся сюда же за адресом.
                  if (!user.isAuth) {
                    setAuthIntent("checkout");
                    setPendingAddressRedirect(true);
                    setAuthOpen(true);
                    return;
                  }

                  // With an address saved this is a "switch address" tap;
                  // with none it's the same "set your address" flow the
                  // order path triggers.
                  if (addresses?.length > 0) {
                    navigate("/profile/addresses");
                    return;
                  }
                  requestCartLocationGate(navigate, {
                    alwaysOpenMap: true,
                    returnTo: "/cart",
                  });
                }}
              >
                <div className="flex flex-row  space-x-2 items-center">
                  <div className="w-9 h-9 bg-fill-background rounded-[10px] flex items-center justify-center">
                    <DeliveryIcon className="text-text-icon-secondary" />
                  </div>
                  <div className="flex flex-col gap-y-[2px] ">
                    <p className="text-body-sm-medium">
                      {truncate(userAddress?.title || t("main.delivery"), 28)}
                    </p>
                    <p className="text-caption-sm-medium text-text-tertiary">
                      {formatDeliveryTime(deliveryTime ? deliveryTime : 30)}
                    </p>
                  </div>
                </div>
                <div className="w-6 h-6 rounded-full bg-fill-background flex items-center justify-center">
                  <ArrowRightIcon className="text-text-icon-secondary" />
                </div>
              </div>
              {/* </TabsContent>
                <TabsContent value="pickup">
                  <div
                    data-testid="cart-pickup-branch-row"
                    className="flex flex-row justify-between items-center px-1 py-2"
                    onClick={() => {
                      impactOccuer("soft");
                      if (!user.isAuth) {
                        setAuthIntent("pickup");
                        setAuthOpen(true);
                        return;
                      }
                      setBranchDrawerOpen(true);
                    }}
                  >
                    <div className="flex flex-row  space-x-2 items-center">
                      <div className="w-9 h-9 bg-fill-background rounded-[10px] flex items-center justify-center">
                        <ForkIcon className="text-text-icon-secondary" />
                      </div>
                      <div className="flex flex-col gap-y-[2px] ">
                        <p className="text-body-sm-medium">
                          {truncate(pickup?.branch?.title || t("pickup"), 28)}
                        </p>
                        <p className="text-caption-sm-medium text-text-tertiary">
                          {hasPickupBranch
                            ? truncate(
                                pickup.branch.address || pickup.branch.title,
                                40,
                              )
                            : t("add-pickup")}
                        </p>
                      </div>
                    </div>
                    <div className="w-6 h-6 rounded-full bg-fill-background flex items-center justify-center">
                      <ArrowRightIcon className="text-text-icon-secondary" />
                    </div>
                  </div>
                  {hasPickupBranch && (
                    <div
                      data-testid="cart-pickup-time-row"
                      className="flex flex-row justify-between items-center px-1 py-2"
                      onClick={() => {
                        impactOccuer("soft");
                        setShowPickupTimePicker(true);
                      }}
                    >
                      <div className="flex flex-row  space-x-2 items-center">
                        <div className="w-9 h-9 bg-fill-background rounded-[10px] flex items-center justify-center">
                          <ClockIcon className="text-text-icon-secondary" />
                        </div>
                        <div className="flex flex-col gap-y-[2px] ">
                          <p className="text-body-sm-medium">
                            {pickup.pickupOn
                              ? t("custom_delivery_time")
                              : t("pickup-time")}
                          </p>
                          <p
                            data-testid="cart-pickup-time-value"
                            className="text-caption-sm-medium text-text-tertiary"
                          >
                            {pickup.pickupOn
                              ? `${t("pickup_window")} ${format(new Date(pickup.pickupOn), "HH:mm")}`
                              : t("fast-delivery")}
                          </p>
                        </div>
                      </div>
                      <div className="w-6 h-6 rounded-full bg-fill-background flex items-center justify-center">
                        <ArrowRightIcon className="text-text-icon-secondary" />
                      </div>
                    </div>
                  )}
                </TabsContent>
              </Tabs> */}
            </Card>

            <Card className="rounded-2xl py-2 flex flex-col mx-4 space-y-1  ">
              {sortedBasketItems.map((item) => (
                <div
                  className={cn(
                    "flex flex-row space-x-2 items-center justify-between",
                    item.isAvailable || isResolving(item)
                      ? "pl-2 pr-3"
                      : // Inset the highlight so it doesn't run edge to edge
                        // inside the card. The padding is trimmed by exactly
                        // the margin added, so rows stay aligned with the
                        // available ones above and below.
                        "mx-2 pl-0 pr-1 py-1 rounded-xl bg-fill-background",
                  )}
                  key={item.cartKey}
                >
                  <div className="flex flex-row items-center space-x-2 ">
                    <ProductImage
                      src={item.menu_image}
                      alt={item.title}
                      className={cn("w-14 h-14 rounded-[10px] object-contain", {
                        "opacity-45": !item.isAvailable && !isResolving(item),
                      })}
                    />
                    <div className="flex flex-col ">
                      {isResolving(item) ? (
                        <Skeleton className="h-3 w-20 rounded-md mb-1" />
                      ) : (
                        !item.isAvailable && (
                          <p className="text-caption-xs-semibold text-red-500">
                            {t("not-available")}
                          </p>
                        )
                      )}
                      <p
                        className={cn("text-caption-sm-medium", {
                          "opacity-45 text-caption-sm-medium":
                            !item.isAvailable && !isResolving(item),
                        })}
                      >
                        {localized(lang, {
                          ru: item.title,
                          uz: item.title_uz,
                          en: item.title_en,
                        })}
                      </p>
                      {item.selectedModifiers &&
                        item.selectedModifiers.length > 0 && (
                          <div className="flex flex-col text-caption-xs-semibold text-text-tertiary">
                            {formatModifierLines(item.selectedModifiers).map(
                              (line, index) => (
                                <p key={index}>{line}</p>
                              )
                            )}
                          </div>
                        )}
                      {user.isAuth && isCalculatingCart ? (
                        <Skeleton className="h-4 w-16 rounded-md my-1" />
                      ) : (
                        <p
                          className={cn("text-body-sm-semibold", {
                            "opacity-45": !item.isAvailable,
                          })}
                        >
                          {formatPrice(getBasketItemUnitPrice(item))} {t("sum")}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Available items get the quantity stepper as one pill.
                      Unavailable ones get two separate controls — keeping the
                      delete inside the "Изменить" pill made it read as a part
                      of that button rather than its own action. */}
                  {isResolving(item) ? (
                    <Skeleton className="h-8 w-[92px] shrink-0 rounded-full" />
                  ) : item.isAvailable ? (
                    <div className="h-8 w-[92px] flex py-[6px] flex-row items-center px-3 space-x-4 justify-center rounded-full bg-button-secondary text-body-sm-semibold text-text-primary">
                      <Button
                        variant="link"
                        className="p-0"
                        onClick={() => handleRemove(item.id, item.cartKey)}
                      >
                        <Minus className="text-text-primary" />
                      </Button>
                      <span className="text-body-sm-semibold">
                        {item.quantity}
                      </span>
                      <Button
                        variant="link"
                        aria-disabled={isCartLimitReached(sortedBasketItems, item)}
                        className={cn("p-0", {
                          "opacity-40": isCartLimitReached(
                            sortedBasketItems,
                            item,
                          ),
                        })}
                        onClick={async () => {
                          impactOccuer("light");
                          queryClient.invalidateQueries({
                            queryKey: ["delivery-detail"],
                          });
                          await addToBasket({
                            product: item,
                            cartKey: item.cartKey,
                            unitPrice: getBasketItemUnitPrice(item),
                            selectedModifiers: item.selectedModifiers,
                          });
                        }}
                      >
                        <PlusIcon className="text-text-primary " />
                      </Button>
                    </div>
                  ) : (
                    <div className="flex shrink-0 flex-row items-center gap-x-2">
                      <Button
                        className="h-8 rounded-full bg-button-secondary px-3 text-body-sm-semibold text-text-primary shadow-none"
                        onClick={() =>
                          handleChangeUnavailable(
                            item.category_id,
                            item.cartKey,
                          )
                        }
                      >
                        {t("change")}
                      </Button>
                      <Button
                        aria-label={t("remove-item")}
                        className="h-8 w-8 shrink-0 rounded-full border border-border bg-transparent p-0 shadow-none"
                        onClick={() => handleRemoveUnavailable(item.cartKey)}
                      >
                        <DeleteIcon className="text-text-primary" />
                      </Button>
                    </div>
                  )}
                </div>
              ))}
            </Card>
            <OrderExtras branchId={branchId} />
            <BasketCrossSellCarousel branchId={branchId} />
            {/* Баллы, промокод и строки итога — на чекауте. Отступ остаётся:
                под ним фиксированная кнопка перехода к оформлению. */}
            <div className="pb-[120px]" />
          </div>
        </div>
      )}
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerContent className="bg-fill-background px-4 pb-safe-bottom">
          <div className="flex flex-col gap-y-2 pt-2">
            <DrawerTitle>{t("remove-item")}</DrawerTitle>
            <p className="text-body-base-regular text-text-tertiary text-left">
              {t("remove-item-description")}
            </p>
          </div>

          {/* Footer Button */}
          <div className="flex flex-col space-y-2 pt-6 pb-4">
            <Button
              className="h-12 w-full rounded-xl bg-button-primary font-semibold"
              onClick={handleRemoveAllNotAvailable}
            >
              <p className="text-body-base-medium  text-text-white">
                {t("accept")}
              </p>
            </Button>
            <Button
              className="h-12 w-full rounded-xl bg-button-secondary font-semibold"
              onClick={() => setOpen(false)}
            >
              <p className="text-body-base-medium  text-text-primary">
                {t("cancel")}
              </p>
            </Button>
          </div>
        </DrawerContent>
      </Drawer>
      <AuthDrawer
        open={authOpen}
        setOpen={(next: boolean) => {
          if (!next) setPendingAddressRedirect(false);
          setAuthOpen(next);
        }}
        onSuccess={() => {
          // if (authIntent === "pickup") {
          //   setBranchDrawerOpen(true);
          //   return;
          // }
          // Вход начался с тапа по строке адреса — ведём за адресом, а не в
          // оформление: без него заказ всё равно не оформить.
          if (pendingAddressRedirect) {
            setPendingAddressRedirect(false);
            requestCartLocationGate(navigate, {
              alwaysOpenMap: true,
              returnTo: "/cart",
            });
            return;
          }

          setPendingCheckoutRedirect(true);
        }}
      />
      {/* Шторка выбора филиала и пикер времени самовывоза отключены вместе с табами. */}
      {/* <PickupBranchDrawer
        open={branchDrawerOpen}
        setOpen={setBranchDrawerOpen}
        returnTo="/cart"
      />
      <Drawer
        open={showPickupTimePicker}
        onOpenChange={(open) => {
          setShowPickupTimePicker(open);
          if (!open) setPickupTimeIssue(null);
        }}
      >
        <DrawerContent className="border-none px-6 pb-safe-bottom max-h-[70vh]">
          <div className="flex flex-col gap-3 pb-4 pt-2">
            <DrawerTitle className="sr-only">{t("pickup-time")}</DrawerTitle>
            {pickupTimeIssue && (
              <p
                data-testid="cart-pickup-time-warning"
                className="text-caption-sm-medium text-red-500 text-center"
              >
                {t(
                  pickupTimeIssue === "too-soon"
                    ? "time-too-soon"
                    : "time-too-late",
                )}
              </p>
            )}
            <DeliveryTimePicker
              value={pickup.pickupOn || undefined}
              minHoursFromNow={PICKUP_MIN_HOURS_FROM_NOW}
              maxDateTime={pickupMaxTime}
              mode="pickup"
              onSelect={(dateTime) => {
                dispatch(setPickupOn(dateTime));
                setShowPickupTimePicker(false);
                setPickupTimeIssue(null);
              }}
              onCancel={() => {
                dispatch(setPickupOn(null));
                setShowPickupTimePicker(false);
                setPickupTimeIssue(null);
              }}
            />
          </div>
        </DrawerContent>
      </Drawer> */}
    </>
  );
};
export default Basket;
